<template>
  <div>
    <div class="contact-us-container hidden-md">
      <div class="contact-us-info-box">
        <div class="contact-us-info-content">
          <p class="wow flipInX animated">{{ $t("contactUs.title") }}</p>
          <p class="wow fadeInUp" data-wow-delay="0.3s">
            {{ $t("contactUs.info1") }}<br />
            {{ $t("contactUs.info2") }}
          </p>
        </div>
      </div>
      <div class="contact-us-orange"></div>
      <div class="contact-us-info">
        <div class="contact-us-info-left wow rotateInUpRight animated">
          <img src="../../assets/images/contactUs/contactus-Pc.png" alt="" />
        </div>
        <div class="contact-detail">
          <!-- <p>{{$t('contactUs.phoneCall')}}:</p>
          <p>
            <img
              src="../../assets/images/contactUs/bluePhone-Pc.png"
              alt="phone"
            />
            <span>0086 312 2196670</span>
          </p> -->

          <p class="wow fadeInUp animated">
            {{ $t("contactUs.mail1") }}
          </p>
          <p class="wow slideInRight animated soya-email">
            <img
              src="../../assets/images/contactUs/blueMail-Pc.png"
              alt="email"
            />
            <span><a href="mailto:info@ora-eu.com">info@ora-eu.com</a></span>
          </p>
          <p class="wow fadeInUp animated" style="display: block">
            <span>{{$t('contactUs.phone1')}}</span>
            <br />
            <span style="fontWeight: 700; color: #333">{{$t('contactUs.phone2')}} 00800-555-99999</span>
          </p>
          <!-- <el-button>{{$t('contactUs.title')}}</el-button> -->
        </div>
      </div>
    </div>
    <div class="visible-md">
      <div class="contact-us-title">
        <div class="contact-us-title-left"></div>
        <div class="contact-us-title-right"></div>
        <div class="contact-us-info-content">
          <p class="wow flipInX animated">{{ $t("contactUs.title") }}</p>
          <p class="wow fadeInUp">
            {{ $t("contactUs.info1") }}<br />
            {{ $t("contactUs.info2") }}
          </p>
        </div>
      </div>
      <div class="contact-us-imgbox">
        <div class="contact-us-imgbox-left"></div>
        <div class="contact-us-imgbox-right"></div>
        <div class="contact-us-imgbox-middle wow rotateInUpRight animated">
          <img
            src="../../assets/images/contactUs/contactus-Mobile.png"
            alt=""
          />
        </div>
      </div>
      <div class="contact-us-info">
        <div class="contact-detail">
          <!-- <p>{{$t('contactUs.phoneCall')}}:</p>
          <p>
            <img
              src="../../assets/images/contactUs/bluePhone-Pc.png"
              alt="phone"
            />
            <span>0086 312 2196670</span>
          </p> -->

          <p class="wow fadeInUp animated">
            {{ $t("contactUs.mail1") }}
          </p>
          <p class="wow fadeInRight animated soya-email" data-wow-delay="0.3s">
            <img
              src="../../assets/images/contactUs/blueMail-Pc.png"
              alt="email"
            />
            <span><a href="mailto:info@ora-eu.com">info@ora-eu.com</a></span>
          </p>
          <p class="wow fadeInUp animated" style="display: block">
            <span>{{$t('contactUs.phone1')}}</span>
            <br />
            <span style="fontWeight: 700; color: #333">{{$t('contactUs.phone2')}} 00800-555-99999</span>
          </p>

          <!-- <el-button>{{$t('contactUs.title')}}</el-button> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { WOW } from "wowjs";
export default {
  mounted() {
    new WOW().init();
  },
};
</script>

<style lang="scss" scoped>
.hidden-md {
  position: relative;
  overflow: visible;
  margin-bottom: 250px;
  //   padding-bottom: 20%;
  display: flex;
  .contact-us-info-box {
    background: #c6e7fb;
    width: 70.83%;
    height: 599px;
    border: 1px solid #000;
    .contact-us-info-content {
      text-align: left;
      //   padding: 15.69% 0 0 26.4%;
      padding: 64px 0 0 26.4%;
      color: #333;
      font-weight: bold;
      & > p:nth-child(1) {
        font-size: 70px;
        font-family: "NexaBold";
      }
      & > p:last-child {
        font-size: 17px;
        font-family: "NexaBold";
        line-height: 36px;
      }
    }
  }
  .contact-us-orange {
    flex: 1;
    background: #ff8a3b;
    height: 500px;
    margin-top: 209px;
    border: 1px solid #000;
    border-left: none;
  }
  .contact-us-info {
    display: flex;
    width: 62.45%;
    height: 477px;
    background: #fff;
    border: 1px solid #000;
    position: absolute;
    // top: 416px;
    top: 460px;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    .contact-us-info-left {
      width: 66.39%;
      margin-top: -8%;
      height: 440px;
      img {
        width: 100%;
        // height: 100%;
      }
    }
    .contact-detail {
      flex: 1;
      text-align: left;
      // margin-left: 5.34%;
      margin-left: 35px;
      padding-right: 20px;
      // margin-top: 90px;
      .el-button {
        color: #333;
        height: 46px;
        border-radius: 23px;
        background: #fff;
        border: 1px solid #000;
        margin-top: 40px;
      }

      p {
        img {
          width: auto;
          margin-right: 10px;
        }
        display: flex;
        align-items: center;
        color: #939597;
        font-family: "NexaLight";
        &:nth-child(odd) {
          font-size: 14px;
          line-height: 21.5px;
          margin-top: 90px;
        }

        &:nth-child(even) {
          font-size: 14px;
          margin-top: 28px;
          color: #13b0b9;
          > span {
            font-family: "NexaLight";
          }
        }

        &:nth-child(3) {
          margin-top: 30px;
        }
      }
    }
  }
}
.visible-md {
  .contact-us-title {
    width: 100%;
    display: flex;
    position: relative;
    .contact-us-title-left {
      background: #c6e7fb;
      width: 70.67%;
      height: 308px;
      position: relative;
      border: 1px solid #000;
    }
    .contact-us-title-right {
      background: #ff8a3b;
      flex: 1;
      height: 217px;
      margin-top: 91px;
      border: 1px solid #000;
      border-left: none;
    }
    .contact-us-info-content {
      position: absolute;
      text-align: left;
      top: 73px;
      left: 16px;
      font-weight: bold;

      p:nth-child(1) {
        font-size: 32px;
        line-height: 40px;
        margin-bottom: 16px;
        font-family: "NexaBold";
      }
      p:last-child {
        font-size: 14px;
        line-height: 24px;
        font-family: "NexaBold";
      }
    }
  }
  .contact-us-imgbox {
    position: relative;
    margin-top: 174px;
    display: flex;
    width: 100%;
    .contact-us-imgbox-left {
      width: 70.83%;
      background: #c6e7fb;
      height: 210px;
      border: 1px solid #000;
    }
    .contact-us-imgbox-right {
      flex: 1;
      background: #ff8a3b;
      border: 1px solid #000;
      border-left: none;
    }
    .contact-us-imgbox-middle {
      width: 92%;
      position: absolute;
      top: -98px;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
      img {
        width: 100%;
      }
    }
  }
  .contact-us-info {
    padding: 50px 50px 110px 54px;
    border-left: 1px solid #000;
    border-right: 1px solid #000;
    .contact-detail {
      text-align: left;
      .el-button {
        color: #333;
        height: 40px;
        border-radius: 20px;
        background: #fff;
        border: 1px solid #000;
        margin-top: 40px;
        font-weight: bold;
      }

      p {
        img {
          width: auto;
          margin-right: 10px;
        }
        display: flex;
        align-items: center;
        color: #939597;
        font-family: "NexaLight";
        &:nth-child(odd) {
          font-size: 14px;
          line-height: 21.5px;
        }

        &:nth-child(even) {
          font-size: 14px;
          margin-top: 0;
          color: #13b0b9;
          margin-top: 30px;
          > span {
            font-family: "NexaLight";
          }
        }

        &:nth-child(3) {
          margin-top: 30px;
        }
      }
    }
  }
}
.soya-email {
  display: inline-block !important;
  border: 1px solid #4ec4ca;
  border-radius: 100px;
  padding: 10px 20px;
  cursor: pointer;
  img {
    width: 18px !important;
  }
  a {
    text-decoration: none;
    color: #13b0b9;
  }
}
</style>